import { createApp } from 'vue';
import SevenZipToZipConverter from '@/Components/SevenZipToZipConverter.vue';
import '@styles/app.css';

createApp(SevenZipToZipConverter).mount('#sevenzip-to-zip-converter');
